// removed by extract-text-webpack-plugin
module.exports = {"current":"weather_current_x","temperature":"weather_current_temperature","temp":"weather_current_temp","degreePicker":"weather_current_degreePicker","fahrenheit":"weather_current_fahrenheit","celsius":"weather_current_celsius","active":"weather_current_active","icon":"weather_current_icon","conditionIcon":"weather_current_conditionIcon","description":"weather_current_description","compact":"weather_current_compact"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/weather-widget/src/components/current/style.less
// module id = 1159
// module chunks = 1